import { View } from "@/components/Theme/View";
import { useThemeColor } from "@/hooks/useThemeColor";
import { StyleSheet } from "react-native";

export const Line = (props) => {

    const {
        style, 
        vertical = false,
        bg = 'rgba(145,145,145,.15)',
        ...rest
    } = props;

    const color = useThemeColor(bg, 'text');
    
    return (
        <View
            style={[styles?.['line' + (vertical === true ? 'Vertical' : '')], style]}
            bg={color}  
            {...rest}
        />
    );

};

const styles = StyleSheet.create({
    line: {
        height: 1, 
        width: '100%',
        alignSelf: 'center'
    },
    lineVertical: {
        width: 1, 
        height: '100%',
        alignSelf: 'center'
    }
});